// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var JsxRuntime = require("react/jsx-runtime");

function SelectBoxNew(props) {
  var __error = props.error;
  var className = props.className;
  var placeholder = props.placeholder;
  var labelCSS = props.labelCSS;
  var errorText = props.errorText;
  var errorCSS = props.errorCSS;
  var error = __error !== undefined ? __error : false;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.label,
                      className: labelCSS !== undefined ? labelCSS : "text-sm font-medium"
                    }),
                JsxRuntime.jsx("select", {
                      children: $$Array.of_list(List.map((function (option) {
                                  return JsxRuntime.jsx("option", {
                                              children: option,
                                              value: option
                                            }, option);
                                }), props.options)),
                      className: className !== undefined ? className : "block border px-3 py-2 border-gray-400 w-3/5 bg-white rounded capitalize text-sm",
                      placeholder: placeholder !== undefined ? placeholder : "",
                      value: props.value,
                      onChange: props.handleChange
                    }),
                error ? JsxRuntime.jsx("div", {
                        children: errorText !== undefined ? errorText : "Error",
                        className: errorCSS !== undefined ? errorCSS : "text-red-600 font-medium float-right"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex justify-between items-center w-full"
            });
}

var make = SelectBoxNew;

exports.make = make;
/* react/jsx-runtime Not a pure module */
